import { dateformat } from "@/utils/utils";

export function currencyFilter(value, symbol, fixed) {
  let zero = 0;
  let result = parseFloat(value);
  fixed = fixed ? fixed : 0;
  if (!isNaN(result) && typeof result == 'number') {
    result = result.toFixed(fixed);
    return symbol ? symbol + result : result;
  } else {
    return symbol ? symbol + zero.toFixed(fixed) : zero.toFixed(fixed);
  }
}

export function unitFilter(value, unit) {
  return unit ? value + unit : value;
}

export function dateformatFilter(dataStr, pattern = "YYYY-MM-DD HH:mm:ss", show) {
  show = show ? true : false;
  return dateformat(dataStr, pattern, show);
}

export function getNameByEmail(email) {
  if (!email) return;
  let arr = email.split('@');
  return arr[0];
}

export function getFirstLetter(str) {
  if (!str) return;
  let l = str.slice(0, 1)
  return l;
}

export function getShorterName(name) {
  if (!name) return '';
  let arr = name.split(' ');
  let sName = ''
  if (arr.length > 0) {
    sName = arr[0];
    for (let i = 1; i < arr.length; i++) {
      if (arr[i].length > 0) {
        sName += ' ' + arr[i][0].toUpperCase();
      }
    }
  }
  return sName;
}